export class AppointmentConstants {
    static EMAIL = "EMAIL";
    static SMS = "SMS";
    static REMINDER_STATUS_SCHEDULED = "Scheduled";
    static REMINDER_STATUS_DELIVERED = "Delivered";
    static REMINDER_STATUS_FAILED = "Failed";
    static APPOINTMENT_REMINDER_NOTIFICATION = "Appointment Reminder";
}

// Video platform backing a video appointment. Must match the API's
// VideoProvider enum (api-common/Constants.ts). Legacy rows may still hold "acs",
// which the app no longer supports: those visits can't be joined until rescheduled.
export const VideoProvider = {
    ZOOM: "zoom",
} as const;

export type VideoProvider = (typeof VideoProvider)[keyof typeof VideoProvider];

/**
 * Where an appointment's details page lives: under the patient's profile, so
 * the patient header (alerts, RPM Only, …) sits above it. Without the patient
 * id, falls back to the legacy /schedule/charting/:id URL, which redirects.
 */
export const appointmentDetailsPath = (
  appointmentId: string,
  patientId?: string | null
): string =>
  patientId
    ? `/patients/${patientId}/appointments/${appointmentId}`
    : `/schedule/charting/${appointmentId}`;

/**
 * Whether a grid row is a video visit from the retired ACS flow. Grid rows don't carry
 * videoProvider, but ACS visits were only ever given an in-app /telehealth link (or no
 * link at all), whereas Zoom visits hold the Zoom join URL.
 */
export const isLegacyAcsVisit = (visit: {
  appointmentMode?: string | null;
  webinarUrl?: string | null;
}): boolean =>
  visit.appointmentMode === "Video Call" &&
  (!visit.webinarUrl || visit.webinarUrl.includes("/telehealth"));
